export default __webpack_public_path__ + "static/media/Nimbus Logo.428240c7.svg";